/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_list__errors__no_result = /** @type {(inputs: {}) => string} */ () => {
	return `Wir haben keine Ergebnisse in dieser Region gefunden. Wiederholen Sie die Suche mit einer erweiterten Suchregion.`
};

const en_poi_list__errors__no_result = /** @type {(inputs: {}) => string} */ () => {
	return `We couldn't find what you're looking for around this location. Try again by expanding your search area.`
};

const es_poi_list__errors__no_result = /** @type {(inputs: {}) => string} */ () => {
	return `No hemos encontrado ningún punto de interés con estos criterios en esta zona. Vuelve a intentarlo ampliando la zona de búsqueda.`
};

const fr_poi_list__errors__no_result = /** @type {(inputs: {}) => string} */ () => {
	return `Nous n'avons pas trouvé ce que vous cherchez autour de cet emplacement. Réessayez en élargissant votre zone de recherche.`
};

const it_poi_list__errors__no_result = /** @type {(inputs: {}) => string} */ () => {
	return `Non abbiamo trovato nessuno dei punti di interesse ricercati nei dintorni. Riprova allargando l’area di ricerca.`
};

const nl_poi_list__errors__no_result = /** @type {(inputs: {}) => string} */ () => {
	return `We hebben geen resultaten gevonden in de buurt van deze locatie. Probeer opnieuw door het zoekgebied te vergroten.`
};

const pt_poi_list__errors__no_result = /** @type {(inputs: {}) => string} */ () => {
	return `Não encontrámos o que procura nesta localização. Tente novamente expandindo a sua área de pesquisa.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_result = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_list__errors__no_result(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_list__errors__no_result", locale)
	if (locale === "de") return de_poi_list__errors__no_result(inputs)
	if (locale === "en") return en_poi_list__errors__no_result(inputs)
	if (locale === "es") return es_poi_list__errors__no_result(inputs)
	if (locale === "fr") return fr_poi_list__errors__no_result(inputs)
	if (locale === "it") return it_poi_list__errors__no_result(inputs)
	if (locale === "nl") return nl_poi_list__errors__no_result(inputs)
	return pt_poi_list__errors__no_result(inputs)
};